import classNames from 'classnames';

import { CheckmarkIcon, CheckmarkFilledIcon, UncheckedIcon, UncheckedXIcon } from '../../../atoms';
import type { ComparisonTableGroup } from '../types';

type Props = ComparisonTableGroup['features'][0]['parameters'][0];

export const FeatureParameterItem = ({ value, variant }: Props) => {
  const isRecommended = variant === 'recommended';

  if (typeof value === 'boolean') {
    return (
      <div className={classNames('features-item-content__feature-boolean', isRecommended && 'recommended')}>
        {value ? (
          <>
            <CheckmarkIcon className="checkmark-icon-default" />
            <CheckmarkFilledIcon className="checkmark-icon-filled" />
          </>
        ) : (
          <>
            <UncheckedIcon className="unchecked-icon-default" />
            <UncheckedXIcon className="unchecked-icon-x" />
          </>
        )}
      </div>
    );
  }

  if (typeof value === 'string') {
    return (
      <div className={classNames('features-item-content__feature-text', isRecommended && 'recommended')}>
        <p>{value}</p>
      </div>
    );
  }

  // never
  return <div />;
};
